import { Injectable } from '@angular/core'
import { PlayTrickErrorCode, Trick } from 'game-services'

@Injectable({ providedIn: 'root' })
export class PlayTrickContent {
  public readonly errorTitle = $localize`:Play trick error title|Invalid trick:Invalid trick`

  public getErrorCodeDescriptions(
    trick: Trick,
    playTrickErrorCodes: PlayTrickErrorCode[],
  ): string[] {
    return playTrickErrorCodes.map((errorCode) =>
      this.getErrorCodeDescription(trick, errorCode),
    )
  }

  private getErrorCodeDescription(
    trick: Trick,
    playTrickErrorCode: PlayTrickErrorCode,
  ): string {
    switch (playTrickErrorCode) {
      case 'InvalidTrick':
        return `${trick.card.rankSymbol}${trick.card.suiteSymbol}`
      default:
        throw new Error(
          `${PlayTrickContent.name} unable to get error description for error code: ${playTrickErrorCode}`,
        )
    }
  }
}
